import {Component, ElementRef, isDevMode, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../../environments/environment";
import {CentreService} from "../../../../services/centre.service";
import {firstValueFrom, forkJoin, Observable, Subject, take} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import jsPDF from 'jspdf';
import {
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexGrid,
  ApexLegend,
  ApexMarkers,
  ApexPlotOptions,
  ApexStroke,
  ApexTitleSubtitle,
  ApexTooltip,
  ApexXAxis,
  ApexYAxis,
} from 'ng-apexcharts';
import {FullChild} from "../../../../interfaces/FullChild";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {ChildService} from "../../../../components/child/child.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute} from "@angular/router";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import {ChangeEvent} from "@ckeditor/ckeditor5-angular";
import {DomSanitizer} from "@angular/platform-browser";
import {MatSelect, MatSelectChange} from "@angular/material/select";
import {PhotoGalleryComponent} from "../../../../components/photo-gallery/photo-gallery.component";
import {MatDialog} from "@angular/material/dialog";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {LoadingService} from "../../../../services/loading.service";
import {EducationService} from "../../../education/education.service";
import {DateRangeFormatService} from "../../../../utils/date-range-format.service";
import {EducationPhotoGalleryComponent} from "../education-presentation/education-photo-gallery/education-photo-gallery.component";
import {endOfDay} from '../../../../utils/date-range-format.service';


export type ChartOptions = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  xaxis: ApexXAxis;
  stroke: ApexStroke;
  dataLabels: ApexDataLabels;
  markers: ApexMarkers;
  colors: string[];
  yaxis: ApexYAxis;
  grid: ApexGrid;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  tooltip: ApexTooltip;
  plotOptions: ApexPlotOptions;
};

@Component({
  selector: 'app-impact-reports',
  templateUrl: './impact-reports.component.html',
  styleUrls: ['./impact-reports.component.scss']
})
export class ImpactReportsComponent implements OnInit, OnDestroy {
  env = isDevMode() ? environment.testMode : environment.productionMode;
  private _destroyed$ = new Subject<void>();
  @ViewChild('content') content!: ElementRef;
  mStartDate: null | Date = null
  mEndDate: null | Date = null
  singleCount = 0
  childrenCount = 0
  mTotalIndividualSession = 0
  baselineArray: any[] = []
  dischargeArray: any[] = []
  public areaChartOptions!: Partial<ChartOptions>;
  mALanguageAverage = 0
  mDLanguageAverage = 0
  mAMathsAverage = 0
  mDMathsAverage = 0
  mAEvsAverage = 0
  mDEvsAverage = 0
  dbType: any;
  storagePath: any;
  centres$: Observable<Centre[]>;
  selectedCentre = "All";
  showDelete = true

  path: any
  mData: any
  selectedChildCode?: any;
  childBycentre: Observable<FullChild[]> | undefined;
  educationData: any
  mShowChart = false
  editorData: any
  public Editor: any = ClassicEditor;
  @ViewChild('selectElement') selectElement!: MatSelect;
  mCentre?: Centre
  mCentres?: Centre[] = []
  selectedSubmit: any;
  colors: any[] = [{backgroundColor: ["#0b5ba8", "#6114be", "#15dcdc"]}];
  mTotalSessions = 0;
  mTeacherSessions = 0;
  mTeacherSessionsGroup = 0;
  mVolunteerSessions = 0;
  mVolunteerSessionsGroup = 0;
  mDaysObserved = 0;
  highlights: any = '';
  mId: string | undefined
  selectedImages: string[] = [];
  selectedImages1: string[] = [];
  selectedImages2: string[] = [];
  mTotalAdmissions: number = 0
  mTotalDischarge: number = 0
  mTotalUnits: number | undefined = 0
  private mTotalAdmissions$: Observable<FullChild[]> | undefined;
  private mTotalDischarge$: Observable<FullChild[]> | undefined;
  selectedGalleryImages: string[] = [];
  // Firestore-backed gallery images (3 categories)
  galleryImagesEdu: any[] = [];
  galleryImagesCelebration: any[] = [];
  galleryImagesVolunteering: any[] = [];
  calculatedSessions = 0
  upload: boolean = false
  reportTypes=["Monthly","Quarter 1","Quarter 2","Quarter 3","Quarter 4","H1","H2","yearly"]
  reportType:string|undefined
  constructor(
    private mCentreService: CentreService,
    private mSnackbar: MatSnackBar,
    private mFirestore: AngularFirestore,
    private afStorage : AngularFireStorage,
    private loader : LoadingService,
    private educationService:EducationService,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private childService: ChildService,
    private dateRangeFormatService : DateRangeFormatService,
    private matDialog: MatDialog) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.centres$.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mCentres = res
    })
    this.areaChartOptions = {
      series: [

        {
          name: 'Written',
          data: [0, 0, 0],
        },
        {
          name: 'Oral',
          data: [0, 0, 0],
        },
      ],
      chart: {
        height: 350,
        type: 'bar',

        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      colors: ['#0e28a6', '#e83108'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: ['Language', 'Maths', 'EVS/GK'],
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
    route.params.pipe(takeUntil(this._destroyed$)).subscribe(res => {
      this.mId = res['id']
      console.log("mid", this.mId)

      if (this.mId) this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId).valueChanges().pipe(takeUntil(this._destroyed$)).subscribe((res: any) => {
        console.log(this.mData)
        if (this.mId != undefined) {
          this.mShowChart = false
          this.mData = res
          console.log(this.mData)
          if (this.mData && this.mData.image) {
            this.selectedImagesEdu = this.mData.image.education || [];
            this.selectedImagesCelebration = this.mData.image.celebration || [];
            this.selectedImagesVolunteering = this.mData.image.volunteering || [];
          }
          // Support both old flat array format and new object format
          const gi = res.galleryImages || {};
          if (Array.isArray(gi)) {
            this.galleryImagesEdu = gi; // backward compat: old flat array → education
            this.galleryImagesCelebration = [];
            this.galleryImagesVolunteering = [];
          } else {
            this.galleryImagesEdu = gi.education || [];
            this.galleryImagesCelebration = gi.celebration || [];
            this.galleryImagesVolunteering = gi.volunteering || [];
          }
          // alert(`into ${this.mData.baseline}`)
          this.mTotalSessions = res?.totalSessions
          this.mTotalAdmissions = res?.totalAdmissionCount
          this.mTotalDischarge = res?.mTotalDischarge
          this.changeSelectedOption(res.centreCode)
          this.mTeacherSessions = res?.teacherSessions
          this.mTeacherSessionsGroup = res?.teacherSessionsGroup
          this.mDaysObserved = res?.daysObserved
          this.mVolunteerSessions = res?.volunteerSessions
          this.highlights = res?.highlights
          this.editorData = res?.highlights
          this.mVolunteerSessionsGroup = res?.volunteerSessionsGroup
          this.reportType = res?.reportType|| "Monthly"
          this.mStartDate = res.from.toDate()
          this.mEndDate = res.to.toDate()
          this.selectedCentre = res.centreCode
          // this.dischargeArray =res.dischargeArray
          // this.admi =res.dischargeArray
          this.mCentre = this.mCentres?.filter(x => x.centreCode == res.centreCode)[0]
          // alert(this.mData.discharge[0].isNaN==undefined)
          this.calculatedSessions = this.mTeacherSessions + this.mTeacherSessionsGroup - this.mDaysObserved
          this.mData = res

          if (res.discharge?.length && !isNaN(res.discharge[0])) {
            this.mShowChart = true
          }
          if (this.mShowChart) this.showChartfromData(this.mData)

        }
      })
    })
  }

  ngOnInit(): void {
    // this.loadExistingImages()
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
  async loadExistingImages(): Promise<void> {
    if (!this.mId) return;
    const docSnap = await this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId).get().toPromise();
    const data: any = docSnap?.data();
    if (data?.image?.education?.length) {
      this.selectedImagesEdu = [...data.image.education]; // Existing image URLs
    }
  }

  selectFile($event: Event) {

  }

  search() {
    // alert('this.mTeacherSessions')

    if (this.selectedCentre != null) {
      this.childBycentre = this.childService.getAllotedChildListByCenterAboveThree(this.selectedCentre!)
      this.childBycentre.pipe(takeUntil(this._destroyed$)).subscribe(res => {
        this.mTeacherSessions = res.length
        // alert('this.mTeacherSessions')
        // alert(this.mTeacherSessions)
      })
    }

  }


  private educationGraph() {
    this.baselineArray = [this.mALanguageAverage, this.mAMathsAverage, this.mAEvsAverage]
    this.dischargeArray = [this.mDLanguageAverage, this.mDMathsAverage, this.mDEvsAverage]
    this.areaChartOptions = {
      ...this.areaChartOptions,
      series: [
        {
          name: 'Baseline',
          data: [this.mALanguageAverage, this.mAMathsAverage, this.mAEvsAverage],
        },
        {
          name: 'Discharge',
          data: [this.mDLanguageAverage, this.mDMathsAverage, this.mDEvsAverage]
        },
      ],
      chart: {
        height: 300,
        type: 'bar',
        toolbar: {
          show: false,
        },
        foreColor: '#9aa0ac',
      },
      colors: ['#0e28a6', '#e83108'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: ['Language', 'Maths', 'EVS/GK'],
        labels: {
          show: true, // Ensure labels are visible
          style: {
            colors: '#000',
            fontSize: '12px',
          },
        },
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
    console.log('ssdsd', isNaN(this.mDLanguageAverage))
    console.log('ssdsd', isNaN(this.mDMathsAverage))
    console.log('ssdsd', isNaN(this.mDEvsAverage))

    if (this.dischargeArray.length != 0) {
      this.mShowChart = true
      // alert('showing chart')
    }
    if (isNaN(this.mDLanguageAverage) || isNaN(this.mDMathsAverage) || isNaN(this.mDEvsAverage)) {
      this.mSnackbar.open('No discharge assessment found', '', {
        panelClass: 'error',
        duration: 3000
      });
      this.mShowChart = false;
    } else {
      this.mShowChart = true;
    }
  }


  async save(): Promise<void> {
    if (this.mStartDate && this.mEndDate) {
      const normalized = this.dateRangeFormatService.normalizeRange(this.mStartDate, this.mEndDate);
      this.mStartDate = normalized.startDate;
      this.mEndDate = normalized.endDate;
    }
    if (!this.selectedSubmit) {
      this.mSnackbar.open('Please select submit type first', '', { duration: 3000, panelClass: 'error' });
      return;
    }
    if (!this.selectedCentre || !this.mStartDate || !this.mEndDate) {
      this.mSnackbar.open('Please enter all fields', '', { duration: 3000, panelClass: 'snackbar-error' });
      return;
    }
    this.loader.setLoading(true); // Start loader
    try {
      const reportRef = this.mFirestore.collection(this.env.educationImpactReport);
      let docId = this.mId;
      const obj: any = {
        highlights: this.highlights?.toString() ?? '',
        teacherSessions: this.mTeacherSessions ?? 0,
        teacherSessionsGroup: this.mTeacherSessionsGroup ?? 0,
        volunteerSessions: this.mVolunteerSessions ?? 0,
        volunteerSessionsGroup: this.mVolunteerSessionsGroup ?? 0,
        daysObserved: this.mDaysObserved ?? 0,
        centreCode: this.selectedCentre ?? '',
        totalSessions:
          (this.mTeacherSessionsGroup ?? 0) +
          (this.mTeacherSessions ?? 0) +
          (this.mVolunteerSessionsGroup ?? 0) +
          (this.mVolunteerSessions ?? 0) -
          (this.mDaysObserved ?? 0),
        totalUnits: this.mTotalUnits ?? 0,
        totalAdmissions: this.mTotalAdmissions ?? 0,
        totalDischarge: this.mTotalDischarge ?? 0,
        from: this.mStartDate ? this.mStartDate : '',
        to: this.mEndDate ? this.mEndDate : '',
        createdAt: new Date(),
        baseline: this.baselineArray ?? [],
        discharge: this.dischargeArray ?? [],
        submitType: this.selectedSubmit ?? '',
        reportType: this.reportType ?? '',
        galleryImages: {
          education: this.galleryImagesEdu || [],
          celebration: this.galleryImagesCelebration || [],
          volunteering: this.galleryImagesVolunteering || [],
        },
        image: {
          education: [] as string[],
          celebration: [] as string[],
          volunteering: [] as string[],
        },
      };

      // Create new doc if needed
      if (!docId) {
        const docRef = await reportRef.add(this.sanitizeForFirestore(obj));
        docId = docRef.id;
      }
      // Load existing images if editing
      let existingImages = {
        education: [] as string[],
        celebration: [] as string[],
        volunteering: [] as string[],
      };
      if (this.mId) {
        const docSnap = await reportRef.doc(this.mId).get().toPromise();
        const data: any = docSnap?.data();
        if (data?.image) {
          existingImages.education = data.image.education || [];
          existingImages.celebration = data.image.celebration || [];
          existingImages.volunteering = data.image.volunteering || [];
        }
      }
      // Upload helper without isNewFile[]
      const uploadFiles = async (files: File[], existingUrls: string[], docId: any, category: string): Promise<string[]> => {
        const urls = [...existingUrls];
        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const filePath = `education-impact-report/${docId}/${category}/${file.name}`;
          const fileRef = this.afStorage.ref(filePath);
          await fileRef.put(file);
          const downloadURL = await fileRef.getDownloadURL().toPromise();
          urls.push(downloadURL);
        }
        return urls;
      };
      this.mSnackbar.open('Uploading images...', '', { duration: 2000 });
      obj.image.education = this.selectedFilesEdu.length > 0
        ? await uploadFiles(this.selectedFilesEdu, existingImages.education, docId, 'education')
        : existingImages.education;
      obj.image.celebration = this.selectedFilesCelebration.length > 0
        ? await uploadFiles(this.selectedFilesCelebration, existingImages.celebration, docId, 'celebration')
        : existingImages.celebration;
      obj.image.volunteering = this.selectedFilesVolunteering.length > 0
        ? await uploadFiles(this.selectedFilesVolunteering, existingImages.volunteering, docId, 'volunteering')
        : existingImages.volunteering;
      // Save final object
      await reportRef.doc(docId).set(this.sanitizeForFirestore(obj), { merge: true });
      this.mSnackbar.open(`Report ${this.mId ? 'Updated' : 'Saved'} Successfully`, '', { duration: 3000 });
      // Reset after save
      this.selectedFilesEdu = [];
      this.selectedImagesEdu = [];
      this.selectedFilesCelebration = [];
      this.selectedImagesCelebration = [];
      this.selectedFilesVolunteering = [];
      this.selectedImagesVolunteering = [];
    } catch (error) {
      console.error('Error saving report:', error);
      this.mSnackbar.open('Error saving report. Please try again.', '', { duration: 3000, panelClass: 'error' });
    } finally {
      this.loader.setLoading(false); // Stop loader
    }
  }


  printDoc() {
    let printContents;
    const previewElement = document.getElementById('preview');
    if (previewElement) {
      printContents = previewElement.innerHTML;
    } else {
      console.error('Element with ID "preview" not found.');
      return; // Exit the function if the element is not found
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
                    <html>
                        <head>
                            <title>Education-Impact-Report</title>
                            <style>
                                body { font-family: Arial, sans-serif; margin: 20px; }
                                p { font-size: 12px; }
                                td, th { font-size: 12px; margin: 0; padding: 0; }
                                tr { padding: 0; }
                                table { border-collapse: collapse; }

                                /* ── Preview image sections ── */
                                .preview-section { margin-top: 28px; margin-bottom: 8px; page-break-inside: avoid; break-inside: avoid; }
                                .preview-section-header { display: flex; align-items: center; gap: 10px; margin-bottom: 14px; }
                                .preview-section-dot { width: 14px; height: 14px; border-radius: 50%; flex-shrink: 0; }
                                .preview-section-title { font-size: 16px; font-weight: 700; margin: 0; text-transform: uppercase; letter-spacing: 0.5px; color: #333; }
                                .preview-section-line { flex: 1; height: 2px; background: #bbb; border-radius: 2px; }
                                .preview-image-grid { display: flex; flex-wrap: wrap; gap: 14px; }
                                .preview-img-wrap { position: relative; width: 150px; flex-shrink: 0; }
                                .preview-img { width: 150px; height: 150px; object-fit: cover; border: 1px solid #ccc; border-radius: 4px; display: block; }
                                .preview-img-actions { display: none !important; }
                                .preview-img-caption { font-size: 10px; color: #666; text-align: center; margin-top: 3px; max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
                                .marginleft { margin-left: 80px; }

                                /* ── Chart container ── */
                                .chart-container { width: 80%; height: 200px; overflow: hidden; }

                                @media print {
                                  .preview-img-actions { display: none !important; }
                                }
                            </style>
                        </head>
                        <body onload="window.print(); window.close();">
                            ${printContents}
                        </body>
                    </html>
                `);
      popupWin.document.close();
    } else {
      console.error('Popup window could not be opened.');
    }

  }


  private showChartfromData(mData: any) {
    // alert('into chart')
    console.log('graph baseline', mData.baseline)
    console.log('graph discharge', mData.discharge)
    mData.baseline =  mData.baseline.map((num:number) => Math.floor(num));
    mData.discharge =  mData.discharge.map((num:number) => Math.floor(num));
    this.areaChartOptions = {
      series: [
        {
          name: 'Baseline',
          data: mData.baseline,
        },
        {
          name: 'Discharge',
          data: mData.discharge
        },
      ],
      chart: {
        height: 350,
        type: 'bar',
        toolbar: {
          show: false,
          tools: {
            download: false // <== line to add
          }
        },
        foreColor: '#9aa0ac',
      },
      colors: ['#0e28a6', '#e83108'],
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: 'smooth',
      },
      xaxis: {
        type: 'category',
        categories: ['Language', 'Maths', 'EVS/GK'],
        // categories: [
        //     '2018-09-19',
        //     '2018-09-20',
        //     '2018-09-21',
        //     '2018-09-22',
        //     '2018-09-23',
        //     '2018-09-24',
        //     '2018-09-25',
        // ],
      },
      legend: {
        show: true,
        position: 'top',
        horizontalAlign: 'center',
        offsetX: 0,
        offsetY: 0,
      },
      grid: {
        show: true,
        borderColor: '#9aa0ac',
        strokeDashArray: 1,
      },
      tooltip: {
        theme: 'dark',
        marker: {
          show: true,
        },
        x: {
          show: true,
        },
      },
    };
    this.mShowChart = true
  }

  /*async Search() {
    this.mTotalAdmissions = 0
    this.mTotalDischarge = 0
    this.mVolunteerSessions = 0
    this.mVolunteerSessionsGroup = 0
    this.mTotalSessions = 0
    this.mTeacherSessions = 0
    this.mTeacherSessionsGroup = 0
    let t = 0
    if (this.mStartDate != null && this.mEndDate != null) this.mFirestore.collection(this.env.education, ref => ref.where('centreCode', '==', this.selectedCentre).where('sessionDate', '>=',
      this.mStartDate).where('sessionDate', '<=', endOfDay(this.mEndDate))
      .where('present', '==', 'Present')
    )
      .valueChanges().subscribe((res: any) => {
        console.log(`totalSessions = ${res.length}`)
        let s = res.filter((x: any) => x.volunteerName == '' || x.volunteerName == null)
        this.mVolunteerSessions = res.filter((x: any) => x.volunteerName != '').length
        this.mTeacherSessions = s.length
        this.educationData = res
        // this.getTotalBaselines(this.educationData)
        this.getTotalDischarges(this.educationData)

        // console.log("res", res)
      })
    if (this.mStartDate != null && this.mEndDate != null) this.mFirestore.collection(this.env.educationGroup, ref => ref.where('centres', 'array-contains', {
      centreName: this.mCentre?.centreName!!,
      centreCode: this.mCentre?.centreCode!!
    }).where('sessionDate', '>=', this.mStartDate).where('sessionDate', '<=', endOfDay(this.mEndDate)))
      .valueChanges().subscribe((res: any) => {
        t = 0
        this.singleCount = 0
        this.childrenCount = 0
        this.mVolunteerSessionsGroup = 0
        // alert( 'ds'+ res.length)
        console.log(`totalSessions = ${res.length}`)
        // this.mTotalSessions = res.length
        // this.mVolunteerSessions = res.filter((x: any) => x.volunteerName != '').length
        this.educationData = res
        // alert(this.educationData.length)
        this.educationData.forEach((it: any) => {

          if (it.countType == 'bysession') {
            this.singleCount++
          } else if (it.countType == 'bychildren') {
            this.childrenCount += it.children.length
          }

          t = this.singleCount + this.childrenCount
          this.mVolunteerSessionsGroup = t
          // console.log('xxxx', this.mVolunteerSessions)
          this.mTeacherSessionsGroup = res.filter((s: any) => s.volunteerName == '').length

        })

        // this.getTotalBaselines(this.educationData)
        // this.getTotalDischarges(this.educationData)
        // this.educationGraph()
        // console.log("res", res)
      })


    if (this.selectedCentre != null && this.mStartDate != null && this.mEndDate != null) {
      console.log("in total admission")
      this.mTotalAdmissions$ = this.mFirestore.collection<FullChild>('ALChild',
        ref => ref.where('centreCode', '==', this.selectedCentre)
      ).valueChanges()
      this.mTotalAdmissions$.subscribe(res => {
        res.forEach(child => {
          child.admissionData.forEach((admission, i) => {
            if (child.admissionData.length >= 1) {
              if (i == 0) {
                if (admission.dateOfAdmission?.toDate()! >= this.mStartDate!! && admission.dateOfAdmission?.toDate()! <= this.mEndDate!!) this.mTotalAdmissions += 1
              }
            }
          })
        })
      })
      this.mTotalDischarge$ = this.mFirestore.collection<FullChild>('ALChild',
        ref => ref.where('centreCode', '==', this.selectedCentre))
        .valueChanges()
      this.mTotalDischarge$.subscribe(res => {
        // alert(res.length)
        res.forEach(child => {
          if (child.admissionData.length > 1 && child.admissionData[1].dateOfDischarge!!.toDate() >= this.mStartDate!! && child.admissionData[1].dateOfDischarge!!.toDate() <= this.mEndDate!!) {
            this.mTotalDischarge += 1
            // console.log('found  ',this.mTotalDischarge  )
          }
        })
      })
    }
    if (this.mStartDate != null && this.mEndDate != null) {
      this.mDaysObserved = await this.fetchSpecialDays(this.mStartDate, this.mEndDate)
    }
    this.mTotalIndividualSession = this.mTeacherSessions + this.mTeacherSessionsGroup - this.mDaysObserved
    this.calculatedSessions = this.mTeacherSessions + this.mTeacherSessionsGroup - this.mDaysObserved
  }*/
  async Search(): Promise<void> {
    this.mTotalAdmissions = 0;
    this.mTotalDischarge = 0;
    this.mVolunteerSessions = 0;
    this.mVolunteerSessionsGroup = 0;
    this.mTotalSessions = 0;
    this.mTeacherSessions = 0;
    this.mTeacherSessionsGroup = 0;
    this.singleCount = 0;
    this.childrenCount = 0;

    if (!this.mStartDate || !this.mEndDate || !this.selectedCentre) return;

    try {
      const start = new Date(this.mStartDate);
      start.setHours(0, 0, 0, 0);
      const end = new Date(this.mEndDate);
      end.setHours(23, 59, 59, 999);

      // Fetch only education data (for charts/details)
      const individualRes = await firstValueFrom(
        this.mFirestore.collection(this.env.education, ref =>
          ref
            .where('centreCode', '==', this.selectedCentre)
            .where('sessionDate', '>=', start)
            .where('sessionDate', '<=', endOfDay(end))
            .where('present', '==', 'Present')
        ).get()
      );

      const groupRes = await firstValueFrom(
        this.mFirestore.collection(this.env.educationGroup, ref =>
          ref
            .where('centres', 'array-contains', {
              centreName: this.mCentre?.centreName ?? '',
              centreCode: this.mCentre?.centreCode ?? ''
            })
            .where('sessionDate', '>=', start)
            .where('sessionDate', '<=', endOfDay(end))
        ).get()
      );

      const admissionsRes = await firstValueFrom(
        this.mFirestore.collection<FullChild>('ALChild', ref =>
          ref.where('centreCode', '==', this.selectedCentre)
        ).get()
      );

      // Extract data from snapshots
      const individual = individualRes.docs.map(doc => doc.data());
      const group = groupRes.docs.map(doc => doc.data());
      const admissions = admissionsRes.docs.map(doc => doc.data());

      // Process individual sessions
      this.mVolunteerSessions = individual.filter((x: any) => x.volunteerName?.trim()).length;
      this.mTeacherSessions = individual.filter((x: any) => !x.volunteerName?.trim()).length;
      this.educationData = individual;

      // Process group sessions
      this.singleCount = 0;
      this.childrenCount = 0;
      group.forEach((it: any) => {
        if (it.countType === 'bysession') {
          this.singleCount++;
        } else if (it.countType === 'bychildren' && Array.isArray(it.children)) {
          this.childrenCount += it.children.length;
        }
      });
      this.mVolunteerSessionsGroup =  this.childrenCount;
      this.mTeacherSessionsGroup = group.filter((s: any) => !s.volunteerName?.trim()).length;
      this.educationData = [...individual, ...group];

      // Count admissions/discharges only
      admissions.forEach(child => {
        const adData = child?.admissionData ?? [];
        if (adData[0]?.dateOfAdmission) {
          const admDate = adData[0].dateOfAdmission?.toDate?.() ?? new Date(adData[0].dateOfAdmission);
          if (admDate >= start && admDate <= end) this.mTotalAdmissions++;
        }
        if (adData[1]?.dateOfDischarge) {
          const disDate = adData[1].dateOfDischarge?.toDate?.() ?? new Date(adData[1].dateOfDischarge);
          if (disDate >= start && disDate <= end) this.mTotalDischarge++;
        }
      });

      // Fetch special days
      this.mDaysObserved = group.filter((x:any)=>x.sessionType=='Special Day').length

      // Calculate totals
      this.mTotalIndividualSession = this.mTeacherSessions + this.mTeacherSessionsGroup - this.mDaysObserved;
      this.calculatedSessions = this.mTotalIndividualSession;

      if (this.educationData?.length) {
        this.getTotalDischarges(this.educationData);
        this.educationGraph()
      }
    } catch (err) {
      console.error('Search error:', err);
      this.mSnackbar.open('Error fetching report data', '', { duration: 3000, panelClass: 'error' });
    }
  }


  private getTotalBaselines(mData: any) {
    this.mALanguageAverage = 0
    this.mAMathsAverage = 0
    this.mAEvsAverage = 0
    let mLanguageTotal = 0
    let mMathsTotal = 0
    let mEvsTotal = 0
    const mBaselines = mData.filter((x: any) => x.sessionType == 'Baseline Assessment')
    console.log('Baselines')
    mBaselines.forEach((it: any) => {
      if (it.languageOral && it.languageWritten) mLanguageTotal += (Number(it.languageOral) + Number(it.languageWritten))
      if (it.mathsOral && it.mathsWritten) mMathsTotal += (Number(it.mathsOral) + Number(it.mathsWritten))
      if (it.evsgkOral && it.evsgkWritten) mEvsTotal += (Number(it.evsgkWritten) + Number(it.evsgkOral))
    })
    this.mALanguageAverage = Number((mLanguageTotal / mBaselines.length).toFixed(2))
    // this.mALanguageAverage = (mLanguageTotal / mBaselines.length)
    this.mAMathsAverage = Number((mMathsTotal / mBaselines.length).toFixed(2))
    // this.mAMathsAverage =(mMathsTotal / mBaselines.length)
    this.mAEvsAverage = Number((mEvsTotal / mBaselines.length).toFixed(2))
    // this.mAEvsAverage = (mEvsTotal / mBaselines.length)
    console.log(`mALanguageTotal: ${mLanguageTotal}`)
    console.log(`mAMathsTotal: ${mMathsTotal}`)
    console.log(`mAEvsTotal: ${mEvsTotal}`)
    console.log(`mALanguageAverage: ${this.mALanguageAverage}`)
    console.log(`mAMathsAverage: ${this.mAMathsAverage}`)
    console.log(`mAEvsAverage: ${this.mAEvsAverage}`)
  }

  // private getTotalBaselinesForChildren(childCodes: string[]) {
  //   // Skip if no child codes provided
  //   if (!childCodes || childCodes.length === 0) {
  //     console.log('No child codes for baseline calculation');
  //     return;
  //   }
  //   const mBaselines: any = []
  //
  //   this.mALanguageAverage = 0
  //   this.mAMathsAverage = 0
  //   this.mAEvsAverage = 0
  //   let mLanguageTotal = 0
  //   let mMathsTotal = 0
  //   let mEvsTotal = 0
  //   const ref = this.mFirestore.collection(this.env.education, ref => ref.where('sessionType', '==', "Baseline Assessment").where('childCode', 'in', childCodes))
  //   ref.valueChanges().subscribe(res => {
  //     res.forEach(it => {
  //         console.log(it)
  //         mBaselines.push(it)
  //       }
  //
  //     )
  //     mBaselines.forEach((it: any) => {
  //       if (it.languageOral && it.languageWritten) mLanguageTotal += (Number(it.languageOral) + Number(it.languageWritten))
  //       if (it.mathsOral && it.mathsWritten) mMathsTotal += (Number(it.mathsOral) + Number(it.mathsWritten))
  //       if (it.evsgkOral && it.evsgkWritten) mEvsTotal += (Number(it.evsgkWritten) + Number(it.evsgkOral))
  //       this.mALanguageAverage = Number((mLanguageTotal / mBaselines.length).toFixed(2))
  //       // this.mALanguageAverage = (mLanguageTotal / mBaselines.length)
  //       this.mAMathsAverage = Number((mMathsTotal / mBaselines.length).toFixed(2))
  //       // this.mAMathsAverage =(mMathsTotal / mBaselines.length)
  //       this.mAEvsAverage = Number((mEvsTotal / mBaselines.length).toFixed(2))
  //
  //       this.mAEvsAverage = (mEvsTotal / mBaselines.length)
  //       console.log(`mALanguageTotal: ${mLanguageTotal}`)
  //       console.log(`mAMathsTotal: ${mMathsTotal}`)
  //       console.log(`mAEvsTotal: ${mEvsTotal}`)
  //       console.log(`mALanguageAverage: ${this.mALanguageAverage}`)
  //       console.log(`mAMathsAverage: ${this.mAMathsAverage}`)
  //       console.log(`mAEvsAverage: ${this.mAEvsAverage}`)
  //       console.log('Baselines')
  //     })
  //
  //     if(childCodes.length== mBaselines.length) {
  //       this.educationGraph()
  //     }else{
  //       // this.mSnackbar.open('Mismatch count in number of discharge and baseline report','',{
  //       //   panelClass: 'error',
  //       //   duration:3000
  //       // })
  //     }
  //   })
  //
  //
  // }
  private async getTotalBaselinesForChildren(childCodes: string[]): Promise<number[]> {
    // 1. Always return an array here
    if (!childCodes || childCodes.length === 0) {
      console.log('No child codes for baseline calculation');
      return [0, 0, 0];
    }

    const codeChunks = this.chunkArray(childCodes, 10);
    const requests = codeChunks.map(chunk =>
      this.mFirestore
        .collection(this.env.education, ref =>
          ref.where('sessionType', '==', 'Baseline Assessment').where('childCode', 'in', chunk)
        )
        .valueChanges()
        .pipe(take(1))
    );

    try {
      const results = await firstValueFrom(forkJoin(requests));
      const allBaselines = results.flat();

      // 2. If the database returned nothing, return zeros
      if (allBaselines.length === 0) return [0, 0, 0];

      let bLang = 0, bMath = 0, bEvs = 0;

      allBaselines.forEach((item: any) => {
        if (item.languageOral || item.languageWritten) {
          bLang += (Number(item.languageOral || 0) + Number(item.languageWritten || 0));
        }
        if (item.mathsOral || item.mathsWritten) {
          bMath += (Number(item.mathsOral || 0) + Number(item.mathsWritten || 0));
        }
        if (item.evsgkOral || item.evsgkWritten) {
          bEvs += (Number(item.evsgkOral || 0) + Number(item.evsgkWritten || 0));
        }
      });

      const totalChildren = childCodes.length || 1;

      // 3. Return the calculated array
      return [
        Number((bLang / totalChildren).toFixed(2)),
        Number((bMath / totalChildren).toFixed(2)),
        Number((bEvs / totalChildren).toFixed(2))
      ];

    } catch (error) {
      console.error('Error in baseline fetch:', error);
      // 4. Return fallback zeros on error
      return [0, 0, 0];
    }
  }
  private chunkArray<T>(array: T[], chunkSize: number): T[][] {
    const chunks: T[][] = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }


  private async getTotalDischarges(mData: any) {
    const childCodesForDischarge: string[] = [];
    let mLanguageTotal = 0;
    let mMathsTotal = 0;
    let mEvsTotal = 0;

    this.mDLanguageAverage = 0;
    this.mDMathsAverage = 0;
    this.mDEvsAverage = 0;

    const mDischarges = mData.filter((x: any) => x.sessionType == 'Discharge Assessment');

    if (mDischarges.length == 0) {
      this.mShowChart = false;
      return;
    }

    mDischarges.forEach((it: any) => {
      childCodesForDischarge.push(it.childCode);
      if (it.languageOral && it.languageWritten) mLanguageTotal += (Number(it.languageOral) + Number(it.languageWritten));
      if (it.mathsOral && it.mathsWritten) mMathsTotal += (Number(it.mathsOral) + Number(it.mathsWritten));
      if (it.evsgkOral && it.evsgkWritten) mEvsTotal += (Number(it.evsgkWritten) + Number(it.evsgkOral));
    });

    // Calculate Discharge Averages
    this.mDLanguageAverage = Number((mLanguageTotal / mDischarges.length).toFixed(2));
    this.mDMathsAverage = Number((mMathsTotal / mDischarges.length).toFixed(2));
    this.mDEvsAverage = Number((mEvsTotal / mDischarges.length).toFixed(2));
    this.dischargeArray = [this.mDLanguageAverage, this.mDMathsAverage, this.mDEvsAverage];

    // FIX: Added 'await' and captured the returned array
    const baselines:any = await this.getTotalBaselinesForChildren(childCodesForDischarge);

    // Now 'baselines' is recognized as an array [lang, math, evs]
    this.mALanguageAverage = baselines[0];
    this.mAMathsAverage = baselines[1];
    this.mAEvsAverage = baselines[2];
    this.baselineArray = [this.mALanguageAverage, this.mAMathsAverage, this.mAEvsAverage];

    // Trigger the graph render
    this.educationGraph();
  }

  onFilesSelecte(event: any) {
    const selectedFiles: FileList = event.target.files;
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles.item(i);
        if (file) {
          // Assuming you want to display image previews and use URLs for <img> tags
          const reader = new FileReader();
          reader.onload = (e: any) => {
            this.selectedImages.push(e.target.result); // Push the URL to the selectedImages array
          };
          reader.readAsDataURL(file); // Convert file to Data URL for preview
        }
      }
    }
  }

  onFilesSelected(event: any): void {
    const files: FileList = event.target.files;
    this.selectedFilesEdu = []; // New files, clear before adding
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file) {
        this.selectedFilesEdu.push(file);
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImagesEdu.push(e.target.result); // New preview (data URL)
        };
        reader.readAsDataURL(file);
      }
    }
  }

  selectedFilesEdu: File[] = [];
  selectedFilesCelebration: File[] = [];
  selectedFilesVolunteering: File[] = [];

  isNewFileEdu: boolean[] = [];
  isNewFileCelebration: boolean[] = [];
  isNewFileVolunteering: boolean[] = [];

  selectedImagesEdu: string[] = [];
  selectedImagesCelebration: string[] = [];
  selectedImagesVolunteering: string[] = [];

  onFilesSelected1(event: any): void {
    const files: FileList = event.target.files;
    this.selectedFilesCelebration = []
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file) {
        this.selectedFilesCelebration.push(file);
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImagesCelebration.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
  }
  onFilesSelected2(event: any): void {
    const files: FileList = event.target.files;
    this.selectedFilesVolunteering = [];
    for (let i = 0; i < files.length; i++) {
      const file = files.item(i);
      if (file) {
        this.selectedFilesVolunteering.push(file);

        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedImagesVolunteering.push(e.target.result);
        };
        reader.readAsDataURL(file);
      }
    }
  }
  onEditorChange($event: ChangeEvent<any>) {
    console.log('editor called!!!')
    const updatedData = $event.editor.getData();
    // this.highlights =this.getSanitizedHTML(updatedData)
    this.highlights = updatedData

    console.log(updatedData);
  }

  getSanitizedHTML(htmlContent: string) {
    return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
  }

  changeSelectedOption(optionValue: string) {
    this.selectedCentre = optionValue;
    setTimeout(() => this.selectElement?.writeValue(optionValue), 0);
  }

  OnCentreChange($event: MatSelectChange) {
    this.mCentre = this.mCentres?.find(x => x.centreCode == $event.value)
    this.mCentres?.find(x => this.mTotalUnits = x.totalUnits)

  }


// Trigger file input programmatically
  triggerFileInput(index: number, category: 'education' | 'celebration' | 'volunteering') {
    const inputId = category === 'education' ? `eduFileInput${index}`
      : category === 'celebration' ? `celeFileInput${index}`
        : `volunFileInput${index}`;
    const fileInput = document.getElementById(inputId) as HTMLInputElement;
    fileInput?.click();
  }

// Delete image from array
  async deleteImageFromArray(index: number, array: string[], category: 'education' | 'celebration' | 'volunteering') {
    const confirmed = confirm('Are you sure you want to delete this image?');
    if (!confirmed) return;
    this.loader.setLoading(true);
    try {
      // Remove from UI arrays
      array.splice(index, 1);
      if (category === 'education') {
        this.selectedFilesEdu.splice(index, 1);
        this.isNewFileEdu.splice(index, 1);
      } else if (category === 'celebration') {
        this.selectedFilesCelebration.splice(index, 1);
        this.isNewFileCelebration.splice(index, 1);
      } else if (category === 'volunteering') {
        this.selectedFilesVolunteering.splice(index, 1);
        this.isNewFileVolunteering.splice(index, 1);
      }

      // Remove from Firestore
      if (this.mId) {
        const reportRef = this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId);
        // Get current images from Firestore
        const docSnap = await reportRef.get().toPromise();
        const data: any = docSnap?.data();
        const images = data?.image?.[category] || [];

        // Remove from Firestore image array
        images.splice(index, 1);

        // Update Firestore
        await reportRef.update({ [`image.${category}`]: images });
      }

      this.mSnackbar.open('Image deleted successfully', '', { duration: 2000 });
    } catch (error) {
      console.error('Error deleting image:', error);
      this.mSnackbar.open('Failed to delete image', '', { duration: 3000, panelClass: 'error' });
    } finally {
      this.loader.setLoading(false);
    }
  }

  previewImageUrl: string | null = null;
  showPreview: boolean = false;

  openImagePreview(imageUrl: any) {
    this.previewImageUrl = imageUrl;
    this.showPreview = true;
  }

  closeImagePreview() {
    this.showPreview = false;
    this.previewImageUrl = null;
  }
  generatePDF() {
    const doc = new jsPDF();

    // Define the HTML content to be added to the PDF
    // @ts-ignore
    const htmlContent = document.getElementById('preview').innerHTML;

    // Add HTML content to the PDF
    doc.html(htmlContent, {
      callback: function (pdf) {
        // Save or download the PDF
        pdf.save('report.pdf');
      }
    });
  }

  openGallery() {
    const dialogRef = this.matDialog.open(PhotoGalleryComponent, {
        height: '90%',
        width: 'auto',
        data: {
          type: 'Education',
          path: `/${this.env.education}`,
          startDate: this.mStartDate,
          endDate: this.mEndDate,
          centreCode: this.selectedCentre
        }
      }
    );
    dialogRef.afterClosed().pipe(takeUntil(this._destroyed$)).subscribe((urls: string[]) => {
      if (!urls?.length) return;
      const newImages = urls.map(url => ({
        url,
        fileName: url.split('%2F').pop()?.split('?')[0] || '',
        centreName: ''
      }));
      this.galleryImagesEdu = [...this.galleryImagesEdu, ...newImages];
    });
  }

  getValues($event: MatSelectChange) {
    this.selectedSubmit = $event.value
    console.log(this.selectedSubmit)

  }

  //new line for comint
async  fetchSpecialDays(startDate: Date, endDate: Date): Promise<number> {
    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();
    const endMonth = endDate.getMonth();
    const endYear = endDate.getFullYear();
//
 let specialDaysDocs = await  this.educationService.fetchSpecialDaysWithinDateRange(startDate, endDate, this.selectedCentre)

  const monthDiff = (endYear - startYear) * 12 + (endMonth - startMonth);

    // Handle negative difference if end date is before start date
    return specialDaysDocs.docs.length||0
  }

  // Example usage in your component

  onEditEducationFilesSelected(event: Event, education: string, index: number): void {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;
    this.uploadEducationImage(file, index);
  }
  async uploadEducationImage(file: File, index: number): Promise<void> {
    this.loader.setLoading(true); // Start loader
    try {
      if (!this.mId) {
        this.mSnackbar.open('Please save the main report first', '', {duration: 3000, panelClass: 'error'});
        return;
      }
      const docRef = this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId);
      const docSnap = await docRef.get().toPromise();
      const data = docSnap?.data() as any;
      const educationImages = data?.image?.education ?? [];
      const filePath = `education-impact-report/${this.mId}/education/${file.name}`;
      const fileRef = this.afStorage.ref(filePath);
      await fileRef.put(file);
      const downloadURL = await fileRef.getDownloadURL().toPromise();
      if (index < educationImages.length) {
        educationImages[index] = downloadURL;
      } else {
        educationImages.push(downloadURL);
      }
      await docRef.update({'image.education': educationImages});
      this.mSnackbar.open('Education image updated successfully', '', {duration: 2000});
    } catch (error) {
      console.error('Error updating education image:', error);
      this.mSnackbar.open('Failed to update education image', '', {duration: 3000, panelClass: 'error'});
    } finally {
      this.loader.setLoading(false); // Stop loader
    }
  }
  onEditCelebrationFilesSelected(event: Event, celebration: string, index: number) {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;
    this.uploadCelebrationImage(file, index);
  }
  async uploadCelebrationImage(file: File, index: number): Promise<void> {
    this.loader.setLoading(true); // Start loader
    try {
      if (!this.mId) {
        this.mSnackbar.open('Please save the main report first', '', { duration: 3000, panelClass: 'error' });
        return;
      }
      const docRef = this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId);
      const docSnap = await docRef.get().toPromise();
      const data = docSnap?.data() as any;
      const celebrationImages = data?.image?.celebration ?? [];
      const filePath = `education-impact-report/${this.mId}/celebration/${file.name}`;
      const fileRef = this.afStorage.ref(filePath);
      await fileRef.put(file);
      const downloadURL = await fileRef.getDownloadURL().toPromise();
      if (index < celebrationImages.length) {
        celebrationImages[index] = downloadURL;
      } else {
        celebrationImages.push(downloadURL);
      }
      await docRef.update({ 'image.celebration': celebrationImages });
      this.mSnackbar.open('Celebration image updated successfully', '', { duration: 2000 });
    } catch (error) {
      console.error('Error updating celebration image:', error);
      this.mSnackbar.open('Failed to update celebration image', '', { duration: 3000, panelClass: 'error' });
    } finally {
      this.loader.setLoading(false); // Stop loader
    }
  }
  onEditVolunteeringFilesSelected(event: Event, celebration: string, index: number) {
    const target = event.target as HTMLInputElement;
    const file = target.files?.[0];
    if (!file) return;
    this.uploadVolunteeringImage(file, index);
  }
  async uploadVolunteeringImage(file: File, index: number): Promise<void> {
    this.loader.setLoading(true)
    try {
      if (!this.mId) {
        this.mSnackbar.open('Please save the main report first', '', { duration: 3000, panelClass: 'error' });
        return;
      }
      const docRef = this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId);
      const docSnap = await docRef.get().toPromise();
      const data = docSnap?.data() as any;
      const volunteeringImages = data?.image?.volunteering ?? [];
      const filePath = `education-impact-report/${this.mId}/volunteering/${file.name}`;
      const fileRef = this.afStorage.ref(filePath);
      await fileRef.put(file);
      const downloadURL = await fileRef.getDownloadURL().toPromise();
      if (index < volunteeringImages.length) {
        volunteeringImages[index] = downloadURL;
      } else {
        volunteeringImages.push(downloadURL);
      }
      await docRef.update({ 'image.volunteering': volunteeringImages });
      this.mSnackbar.open(`volunteering image updated successfully`, '', { duration: 2000 });
    } catch (error) {
      console.error('Error updating volunteering image:', error);
      this.mSnackbar.open('Failed to update volunteering image', '', { duration: 3000, panelClass: 'error' });
    } finally {
      this.loader.setLoading(false)
    }
  }
  /**
   * Handles report type selection and sets date range based on financial year
   * @param {MatSelectChange} $event - Material select change event containing selected report type
   * @description Sets start and end dates based on selected report type:
   * - Monthly: Current month
   * - Quarters (1-4): 3 month periods starting from April
   * - Half Years: 6 month periods starting from April
   * - Full Years: April to March of specified year range
   */
  onReportTypeSelect($event: MatSelectChange): void {
    // const reportTypes = ["Monthly", "Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4", "1st Half", "Second Half", "2024-2025", "2025-2026"];
    this.reportType = $event.value;

    const now = new Date();
    const currentMonth = now.getMonth();
    const currentYear = now.getFullYear();

    switch(this.reportType) {
      case "Monthly":
        this.mStartDate = new Date(currentYear, currentMonth, 1);
        this.mEndDate = new Date(currentYear, currentMonth + 1, 0);
        break;

      case "Quarter 1":
        this.mStartDate = new Date(currentYear, 3, 1); // April 1st
        this.mEndDate = new Date(currentYear, 5, 30); // June 30th
        break;

      case "Quarter 2":
        this.mStartDate = new Date(currentYear, 6, 1); // July 1st
        this.mEndDate = new Date(currentYear, 8, 30); // September 30th
        break;

      case "Quarter 3":
        this.mStartDate = new Date(currentYear, 9, 1); // October 1st
        this.mEndDate = new Date(currentYear, 11, 31); // December 31st
        break;

      case "Quarter 4":
        this.mStartDate = new Date(currentYear + 1, 0, 1); // January 1st
        this.mEndDate = new Date(currentYear + 1, 2, 31); // March 31st
        break;

      case "H1":
        this.mStartDate = new Date(currentYear, 3, 1); // April 1st
        this.mEndDate = new Date(currentYear, 8, 30); // September 30th
        break;

      case "H2":
        this.mStartDate = new Date(currentYear, 9, 1); // October 1st
        this.mEndDate = new Date(currentYear + 1, 2, 31); // March 31st
        break;

      //
      case "yearly": {
        const today = new Date();
        const year = today.getFullYear();
        const month = today.getMonth(); // 0 = Jan

        // If current month is Jan–Mar → financial year started last year
        if (month < 3) {
          this.mStartDate = new Date(year - 1, 3, 1); // Apr 1 (last year)
          this.mEndDate = new Date(year, 2, 31);      // Mar 31 (current year)
        }
        // If Apr–Dec → financial year ends next year
        else {
          this.mStartDate = new Date(year, 3, 1);     // Apr 1 (current year)
          this.mEndDate = new Date(year + 1, 2, 31);  // Mar 31 (next year)
        }
        break;
      }

    }
  }

  get hasChartData(): boolean {
    const series = this.areaChartOptions?.series;
    if (!series || series.length === 0) return false;
    return series.some((s: any) =>
      Array.isArray(s.data) && s.data.some((val: number) => val > 0)
    );
  }

  /**
   * Open education photo gallery dialog for a specific category
   */
  openPhotoGallery(category: 'education' | 'celebration' | 'volunteering'): void {
    if (!this.selectedCentre || !this.mStartDate || !this.mEndDate) {
      this.mSnackbar.open('Please select a centre and date range first', '', { duration: 3000 });
      return;
    }

    const dialogRef = this.matDialog.open(EducationPhotoGalleryComponent, {
      width: '90vw',
      maxWidth: '1400px',
      height: '90vh',
      data: {
        centreCode: this.selectedCentre || '',
        startDate: this.mStartDate,
        endDate: this.mEndDate
      }
    });

    dialogRef.afterClosed().pipe(takeUntil(this._destroyed$)).subscribe(result => {
      if (result && Array.isArray(result)) {
        if (category === 'education') {
          this.galleryImagesEdu = [...this.galleryImagesEdu, ...result];
        } else if (category === 'celebration') {
          this.galleryImagesCelebration = [...this.galleryImagesCelebration, ...result];
        } else {
          this.galleryImagesVolunteering = [...this.galleryImagesVolunteering, ...result];
        }
        this.mSnackbar.open(`${result.length} image(s) added to ${category} gallery`, '', { duration: 3000 });
      }
    });
  }

  async removeImageFromGallery(index: number, category: 'education' | 'celebration' | 'volunteering'): Promise<void> {
    if (category === 'education' && index >= 0 && index < this.galleryImagesEdu.length) {
      this.galleryImagesEdu.splice(index, 1);
    } else if (category === 'celebration' && index >= 0 && index < this.galleryImagesCelebration.length) {
      this.galleryImagesCelebration.splice(index, 1);
    } else if (category === 'volunteering' && index >= 0 && index < this.galleryImagesVolunteering.length) {
      this.galleryImagesVolunteering.splice(index, 1);
    }
    if (this.mId) {
      try {
        await this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId).update({
          'galleryImages.education': this.galleryImagesEdu,
          'galleryImages.celebration': this.galleryImagesCelebration,
          'galleryImages.volunteering': this.galleryImagesVolunteering,
        });
      } catch (e) {
        console.error('Failed to persist gallery removal', e);
      }
    }
    this.mSnackbar.open('Image removed from gallery', '', { duration: 2000 });
  }

  async clearGallery(category: 'education' | 'celebration' | 'volunteering'): Promise<void> {
    if (category === 'education') { this.galleryImagesEdu = []; }
    else if (category === 'celebration') { this.galleryImagesCelebration = []; }
    else { this.galleryImagesVolunteering = []; }
    if (this.mId) {
      try {
        await this.mFirestore.collection(this.env.educationImpactReport).doc(this.mId)
          .update({ [`galleryImages.${category}`]: [] });
      } catch (e) {
        console.error('Failed to persist gallery clear', e);
      }
    }
    this.mSnackbar.open(`${category} gallery cleared`, '', { duration: 2000 });
  }

  openImageInNewTab(url: string): void {
    window.open(url, '_blank');
  }

  private sanitizeForFirestore(data: any): any {
    if (data === undefined) return null;
    if (data === null || typeof data !== 'object') return data;
    if (data instanceof Date) return data;
    if (Array.isArray(data)) return data.map(item => this.sanitizeForFirestore(item));
    const result: any = {};
    for (const key of Object.keys(data)) {
      result[key] = this.sanitizeForFirestore(data[key]);
    }
    return result;
  }

}
